import edgarPic from "@/public/images/artists/edgar.png";
import { Artist } from "@/types/types";

export const edgar = {
  id: "194",
  name: "Edgar",
  image: edgarPic,
  description: `Edgar's voice is clear and commanding, with a raw texture that lends character and intensity. His powerful belting and controlled vocal fry create an intense, authoritative sound that thrives across rock and metal.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fedgar-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Gritty", "Rock", "Belting", "Country"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 47,
        high: 70,
      },
      sweetSpot: 56,
    },
  },
} as const satisfies Artist;
